import { toOrganization } from '@/api/mappers/mapOrganization';
import { toApiStatus, toStatus } from '@/api/mappers/mapStatus';
import { Retailer as ApiRetailer, RetailerCreateRequest, RetailerUpdateRequest } from '@/gen/api';
import { RetailerCreate, Retailer as RetailerModel, RetailerUpdate } from '@/models/Retailer';

export const toRetailer = (apiRetailer: ApiRetailer): RetailerModel => {
  return {
    ...apiRetailer,
    status: toStatus(apiRetailer.status),
    organization: apiRetailer.organization ? toOrganization(apiRetailer.organization) : undefined,
  };
};

export const toApiRetailer = (retailer: RetailerModel): ApiRetailer => {
  return {
    ...retailer,
    status: toApiStatus(retailer.status),
    organization: undefined,
  };
};

export const toApiRetailerCreateRequest = (retailer: RetailerCreate): RetailerCreateRequest => {
  return {
    ...retailer,
    externalCode: retailer.externalCode || '',
  };
};

export const toApiRetailerUpdateRequest = (retailer: RetailerUpdate): RetailerUpdateRequest => {
  return {
    ...retailer,
    externalCode: retailer.externalCode || '',
    status: toApiStatus(retailer.status),
  };
};
